
import React from 'react';
import swal from "sweetalert";
import FusionCharts from "fusioncharts/core";
import Column3D from 'fusioncharts/viz/column3d';

FusionCharts.addDep(Column3D);

class DaysChart extends React.Component
{
    constructor(props) {
        super(props);
        this.state = {
            days: {},
            config: {},
            ctx: {}
        };
    }

    componentWillMount()
    {
        let self = this;
    }

    openAlgo()
    {
        console.log("OPEN!");
    }

    componentDidMount()
    {
        let self = this;

        let month_url = "";

        switch (month) {
            case "enero": month_url = "01"; break;
            case "febrero": month_url = "02"; break;
            case "marzo": month_url = "03"; break;
            case "abril": month_url = "04"; break;
            case "mayo": month_url = "05"; break;
            case "junio": month_url = "06"; break;
            case "julio": month_url = "07"; break;
            case "agosto": month_url = "08"; break;
            case "septiembre": month_url = "09"; break;
            case "octubre": month_url = "10"; break;
            case "noviembre": month_url = "11"; break;
            case "diciembre": month_url = "12"; break;
        }

        if (year >= 2023) {
            axios.get('/api/reports/' + month_url + '/' + year + '/days')
            .then(response => {
                let days = response.data.days;
                let labels = days.labels;
                let values = days.count;

                let data = [];

                for (let i = 0; i < labels.length; i++) {
                    let data_json = {
                        label: labels[i],
                        value: values[i]
                    };

                    data.push(data_json);
                }

                const dataSource = {
                    "chart": {
                        "yaxisname": "Códigos",
                        "rotatelabels": "1",
                        "setadaptiveymin": "1",
                        "theme": "fusion",
                        "bgColor": "#ffffff",
                        "bgAlpha": "0",
                        "palettecolors":"5d62b5,29c3be,f2726f",
                        "showBorder": "1",
                        "borderThickness": "0",
                        "canvasPadding": "0",
                        "showCanvasBorder": "0",
                        "labelDisplay": "rotate",
                        "slantLabel": "1"
                    },
                    "data": data
                };

                FusionCharts.ready(function() {
                    let myChart = new FusionCharts({
                        type: "column3d",
                        renderAt: "days-chart",
                        width: "100%",
                        height: "511",
                        dataFormat: "json",
                        dataSource
                    }).render();

                    myChart.setTransparent(true);
                });
            })
            .catch(error => {

                console.log(error);

                swal({
                    title: "¡Oh no!",
                    text: "No se han obtenido resultados.",
                    icon: "warning",
                });
            });
        }
    }

    render()
    {
        return (
            <div className="card-box widget-box-1 bg-white">
                <h4 className="text-dark"
                    style={{ fontSize: "large", fontWeight: "bold" }}>
                    Redención diaria
                </h4>

                <div id='days-chart'></div>
            </div>
        );
    }
}

export default DaysChart;


// WEBPACK FOOTER //
// ./resources/assets/react/dashboard/DaysChart.jsx